export default "__VITE_ASSET__6itU97aF__"